import { render, staticRenderFns } from "./TextareaView.vue?vue&type=template&id=243f0a12&"
import script from "./TextareaView.vue?vue&type=script&lang=js&"
export * from "./TextareaView.vue?vue&type=script&lang=js&"
import style0 from "./TextareaView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('243f0a12', component.options)
    } else {
      api.reload('243f0a12', component.options)
    }
    module.hot.accept("./TextareaView.vue?vue&type=template&id=243f0a12&", function () {
      api.rerender('243f0a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/TextareaView.vue"
export default component.exports